{
  "login": {
    "heading": "Formular-Generator",
    "lead": "Erstellen Sie einfach schöne Formulare.",
    "forgotLink": "Passwort vergessen?",
    "registerLink": "Anfrage Zugang",
    "username": "Nutzername",
    "usernamePlaceholder": "name@mail.com",
    "password": "Passwort",
    "passwordPlaceholder": "Passwort",
    "identityError": "Das eingegebene Passwort ist falsch.",
    "signInLoading": "Einloggen…",
    "signInLabel": "Einloggen"
  },
  "modal": {
    "confirm": {
      "ok": "Ok",
      "cancel": "Absagen"
    },
    "form": {
      "submit": "einreichen"
    }
  },
  "explorer": {
    "add": "Hinzufügen"
  }
}